import { createSlice } from "@reduxjs/toolkit";

const initialState = {};

const tableSlice = createSlice({
  name: "table",

  initialState,

  reducers: {

    setTableState: (state, action) => {

      const { tableName, data } = action.payload;

      state[tableName] = {
        ...state[tableName],
        ...data,
      };
    },

    resetTableState: (state, action) => {

      const tableName = action.payload;

      state[tableName] = {
        page: 1,
        limit: 10,
        search: "",
        status: "",
      };
    },
  },
});

export const {
  setTableState,
  resetTableState,
} = tableSlice.actions;

export default tableSlice.reducer;